import type { CustomField, CustomFieldValue, CustomFieldValues } from '@/api/customFields';

export interface FieldEntry {
  field: CustomField;
  defaultValue?: CustomFieldValue;
}

/** Setzt Default-Werte für noch leere Felder (neue Einträge). */
export function withDefaults(fields: FieldEntry[], values: CustomFieldValues): CustomFieldValues {
  const next = { ...values };
  for (const f of fields) {
    if ((next[f.field.id] === undefined || next[f.field.id] === null) && f.defaultValue != null) {
      next[f.field.id] = f.defaultValue;
    }
  }
  return next;
}

/** Fehlende Pflichtfelder (für die Validierung vor dem Speichern). */
export function missingRequired(fields: FieldEntry[], values: CustomFieldValues): CustomField[] {
  return fields
    .filter((f) => f.field.required)
    .filter((f) => {
      const v = values[f.field.id];
      return v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
    })
    .map((f) => f.field);
}
